import { Facebook } from "lucide-react";

const FB_URL = "https://www.facebook.com/p/Flatlander-trucking-llc-100076240866675/";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-ink pb-28 pt-12 md:pb-12">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-5 sm:px-8 md:flex-row md:items-center">
        <div>
          <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-white">
            FlatlanderTrucking<span className="text-ember">.com</span>
          </p>
          <p className="mt-1 font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
            24/7 Towing &amp; Heavy Roadside Repair — Rittman, OH
          </p>
          <p className="mt-3 text-xs leading-relaxed text-slate-500" data-testid="footer-address">
            10010 Sterling Rd, Rittman, OH 44270 · 10630 Berea Rd, Cleveland, OH ·{" "}
            <a href="mailto:flatlander_trucking@yahoo.com" data-testid="footer-email-link" className="transition-colors duration-200 hover:text-ember">
              flatlander_trucking@yahoo.com
            </a>
          </p>
        </div>
        <div className="flex items-center gap-6">
          <a href="tel:+13302014612" data-testid="footer-phone-link" className="font-mono text-xs uppercase tracking-widest text-slate-400 transition-colors duration-200 hover:text-ember">
            (330) 201-4612
          </a>
          <a
            href={FB_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-slate-400 transition-colors duration-200 hover:text-ember"
          >
            <Facebook className="h-4 w-4" />
            Facebook
          </a>
          <a href="/admin" data-testid="footer-admin-link" className="font-mono text-xs uppercase tracking-widest text-slate-500 transition-colors duration-200 hover:text-ember">
            Dispatch Login
          </a>
        </div>
      </div>
    </footer>
  );
}
